import OBase from './OBase';

import * as Geometry from '../geometry';

export default class Equality extends OBase {
  update () {
    var aValTree = this.getFloatInput('First Number');
    var bValTree = this.getFloatInput('Second Number');

    var pOutput1 = this.getGenericObjectOutput('Equality');
    var pOutput2 = this.getGenericObjectOutput('Inequality');

    var dataTrees = [];
    var outDataTrees = [];
    dataTrees.push(aValTree, bValTree);

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    var outTree1 = new Geometry.DataTree();
    var outTree2 = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        var aVal = outDataTrees[0].branches[i][j];
        var bVal = outDataTrees[1].branches[i][j];

        let val = false;
        if (aVal === bVal) {
          val = true;
        }
        outTree1.add(val, outDataTrees[0].paths[i]);
        outTree2.add(!val, outDataTrees[0].paths[i]);
      }
    }

    pOutput1.value = outTree1;
    pOutput2.value = outTree2;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Equality.js